<template>
  <div class="groupbuy-list-wrapper" v-loading="loading">
    <div class="header-wrapper">
      <h3 class="title">{{shopInfo.name}} / 团购管理</h3>
      <div class="btn-group">
        <el-button type="primary" icon="plus" size="small" @click="showGrouponDialog">添加团购</el-button>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="grouponList"
        stripe
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="60">
        </el-table-column>
        <el-table-column
          align="center"
          label="团购图片"
          width="120">
          <template slot-scope="scope">
            <div class="groupon-pic-col">
              <img :src="scope.row.img | ossurl"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="团购名称"
          width="280">
        </el-table-column>
        <el-table-column
          label="开始／结束时间"
          width="200">
          <template slot-scope="scope">
            {{scope.row.start_time | dateTimeFormatter('yyyy-MM-dd')}} / {{scope.row.end_time | dateTimeFormatter('yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-tag>{{scope.row.status | grouponStatus}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <router-link :to="`/shop/${shopInfo.id}/group/${scope.row.id}`">
              <el-button size="small">查看</el-button>
            </router-link>
            <el-button size="small" @click="edit(scope.row.id)">编辑</el-button>
            <el-button size="small" @click="copy(scope.row.id)">一键复制开团</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-block">
      <el-pagination
        @current-change="currentPageChanged"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <groupon-dialog ref="grouponDialog" :title="dialogTitle" @added="handleAdded"></groupon-dialog>
  </div>
</template>

<script>
import grouponDialog from '@/components/add-groupon-dialog.vue'

export default {
  name: 'shop-group-buy-list',
  components: {
    grouponDialog
  },
  data () {
    return {
      dialogTitle: '发布新团购',
      grouponList: [],
      loading: false,
      orderList: [],
      currentPage: 1,
      totalPage: null,
      totalCount: 0,
      pageSize: 10
    }
  },
  computed: {
    shopInfo () {
      return this.$store.getters['shop/shopInfo']
    }
  },
  watch: {
    '$route' (to, from) {
      this.$store.commit('shop/setShopId', Number(this.$route.params.sid))
      this.currentPageChanged()
    }
  },
  mounted () {
    this.$store.commit('shop/setShopId', Number(this.$route.params.sid))
    this.currentPageChanged()
  },
  methods: {
    edit (grouponId) {
      this.dialogTitle = '更新团购'
      this.$refs.grouponDialog.open(grouponId)
    },
    copy (grouponId) {
      this.dialogTitle = '复制团购'
      this.$refs.grouponDialog.copy(grouponId)
    },
    showGrouponDialog () {
      this.dialogTitle = '发布新团购'
      this.$refs.grouponDialog.open()
    },
    handleAdded () {
      this.$refs.grouponDialog.close()
      this.currentPageChanged()
    },
    currentPageChanged () {
      this.loading = true
      this.$store.dispatch('shop/fetchGrouponList', {
        page: this.currentPage,
        size: this.pageSize,
        shopId: Number(this.$route.params.sid)
      }).then((res) => {
        this.currentPage = res.current_page
        this.totalPage = res.total_page
        this.totalCount = res.total_count
        this.grouponList = res.groupons
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="sass">
.groupbuy-list-wrapper
  padding: 20px;
  .header-wrapper
    overflow: hidden;
    margin-bottom: 10px;
  .title
    font-size: 14px;
    line-height: 2;
    font-weight: 600;
    float: left;
  .btn-group
    float: right;
  .product-list-wrapper
    .del-groupon
      position: absolute;
      top: 10px;
      left: 10px;
    .product-form
      position: relative;
      border: 1px dashed #777;
      padding: 10px;
      border-radius: 5px;
  .date-range-picker
    width: 100%;
  .page-block
    padding-top: 20px
    text-align: center

  .groupon-pic-col
    max-height: 100px;
    max-width: 100px;
    padding: 5px;
</style>



// WEBPACK FOOTER //
// groupon-list.vue?3b8181ea